import React from "react"
import AllTopics from "./components/AllTopics"
export const Topics = () => {
  return (
    <div>
      <AllTopics />
    </div>
  )
}
